import React, { Component } from 'react';
import { TableFooter, TableRow, TablePagination } from '@mui/material';
import Pagination from './Pagination';
import { size } from "lodash"

class TableFooterPagination extends Component {
    state = { 
        rowsPerPage: 10,
        page: 0,
        from: 1,
        to: 20,
    }

    // componentDidMount = () => {
    //     if (this.props.initialPage) {
    //         this.setState({
    //             page: this.props.initialPage,
    //             // from: page *rowsPerPage + 1,
    //             // to: page *rowsPerPage + rowsPerPage
    //         })
    //     }
    // }
    // shouldComponentUpdate = (nextProps) => {
    //     console.log('====================================');
    //     console.log(nextProps, this.props);
    //     console.log({init: nextProps.initialPage, oldInit: this.props.initialPage});
    //     console.log('====================================');
    //     if (nextProps.initialPage === 0 && this.props.initialPage !== 0){
    //         this.reset()
    //     }
    //     return true
    // }
    // handleChangePage = (event, page) => {
    //     const { rowsPerPage } = this.state;
    //     let pageOfItems = this.props.items && this.props.items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    //     this.setState({ 
    //         page,
    //         // from: page *rowsPerPage + 1,
    //         // to: page *rowsPerPage + rowsPerPage
    //     });
    //     this.props.onPageChange(pageOfItems, page, rowsPerPage)
    // };
    
    // handleChangeRowsPerPage = event => {
    //     this.setState({ page: 0, from: 1, rowsPerPage: parseInt(event.target.value) });
    // };
    // reset = () => {
    //     this.setState({
    //         page: 0,
    //         // from: 0 * this.state.rowsPerPage + 1,
    //         // to: 0 * this.state.rowsPerPage + this.state.rowsPerPage
    //     })
    // }
    render() {
        // const { page, rowsPerPage} = this.state;
        // console.log("STATE",this.state)
        // console.log("PROPS",this.props)
        // let count = this.props.count || size(this.props.items)
        
        return (
            <TableFooter>
                <TableRow>
                    <TablePagination
                        rowsPerPageOptions={this.props.rowsPerPageOptions || [20, 40]}
                        colSpan={this.props.colSpan || 7}
                        count={this.props.count}
                        rowsPerPage={this.props.rowsPerPage}
                        page={this.props.page}
                        SelectProps={{
                            native: true,
                        }}
                        labelDisplayedRows ={({from, to, count}) => `${from}-${to} sur ${count !== -1 ? count : `plus de ${to}`}`}
                        onPageChange={this.props.onPageChange}
                        onRowsPerPageChange={this.props.onRowsPerPageChange}
                        ActionsComponent={Pagination}
                        labelRowsPerPage="Lignes par Page"
                    />
                </TableRow>
            </TableFooter>
        );
    }
}

export default TableFooterPagination;